import React from 'react'
import PropTypes from 'prop-types'

const RadioButtonComponent = ({
  style,
  input_style,
  label,
  type,
  name,
  field_name,
  value,
  onChange,
  required,
  hidden,
  disabled,
  display,
}) => {
  const genderOptions = [
    { label: 'Male', value: '1' },
    { label: 'Female', value: '2' },
    // { label: 'Others', value: '3' }
  ]

  const maritalStatusOptions = [
    { label: 'Single', value: '1' },
    { label: 'Married', value: '2' },
    { label: 'Widowed', value: '3' },
    { label: 'Divorced', value: '4' },
    { label: 'Separated', value: '5' },
    { label: 'Others', value: '6' },
  ]

  const idSettingOptions = [
    { label: 'Automatic', value: '1' },
    { label: 'Manual', value: '2' },
    { label: 'None', value: '3' },
  ]

  const mailSettingOptions = [
    { label: 'Admin Configured Email IDs', value: '1' },
    { label: 'Login Employee Configured Email ID', value: '2' },
  ]

  const statusTypeOptions = [
    { label: 'Followup', value: '1' },
    { label: 'Notification', value: '2' },
    { label: 'Closed', value: '3' },
    { label: 'Completed', value: '4' },
  ]

  const uomOptions = [
    { label: 'Piece', value: 'Piece' },
    { label: 'Nos', value: 'Nos' },
    { label: 'Kg', value: 'Kg' },
    { label: 'grams', value: 'grams' },
    { label: 'liter', value: 'liter' },
    { label: 'ml', value: 'ml' },
  ]

  const transmissionTypeOptions = [
    { label: 'Manual', value: '1' },
    { label: 'Automatic', value: '2' },
  ]

  const fuelTypeOptions = [
    { label: 'Diesel', value: '1' },
    { label: 'Petrol', value: '2' },
    { label: 'Gas', value: '3' },
    { label: 'Electrical', value: '4' },
    { label: 'Hydrogen', value: '5' },,
  ]

  const numberPlateOptions = [
    { label: 'White', value: '1' },
    { label: 'Yellow', value: '2' },
    { label: 'Black', value: '3' },
    { label: 'Blue', value: '4' },
    { label: 'Green', value: '5' },,
  ]

  const mealTypeOptions = [
    { label: 'Breakfast', value: '1' },
    { label: 'Lunch', value: '2' },
    { label: 'Dinner', value: '3' },
  ]

  const foodTypeOptions = [
    { label: 'Veg', value: '1' },
    { label: 'Non Veg', value: '2' },
  ]

  const foodOrderOptions = [
    { value: 'OT', label: 'One Time' },
    { value: 'SB', label: 'Subscription' },
  ]

  let options = genderOptions;
  if(field_name === "gender"){
    options = genderOptions;
  }else if(field_name === "marital_status"){
    options = maritalStatusOptions;
  }else if(field_name === "type"){
    options = idSettingOptions;
  }else if(field_name === "status_type"){
    options = statusTypeOptions;
  }else if(field_name === "uom"){
    options = uomOptions;
  }else if(field_name === "transmission_type"){
    options = transmissionTypeOptions;
  }else if(field_name === "fuel_type"){
    options = fuelTypeOptions;
  }else if(field_name === "number_plate"){
    options = numberPlateOptions;
  }else if(field_name === "mail_setting_type"){
    options = mailSettingOptions;
  }else if(field_name === "meal_type"){
    options = mealTypeOptions;
  }else if(field_name === "food_type"){
    options = foodTypeOptions;
  }else if(field_name === "food_order_type"){
    options = foodOrderOptions;
  }


  if (hidden) return null

  return (
    <>
      {display
        ?
        <div className={`${style}`} >
          {label !== "" &&
            <label htmlFor={name} className="form-label" >
              {required && <span className="text-danger"> * </span>}{label}
            </label>
          }
          <div className="flex">
            {options.map((option) => (
              <label
                key={option.value}
                htmlFor={`radio-${name}-${option.value}`}
                className={`cursor-pointer flex items-center px-4 py-2 rounded-full border-2 transition-all duration-300 
              ${value === option.value
                    ? 'font-semibold text-blue-500 border-blue-700 shadow-md'
                    : 'border-gray-300 bg-white text-gray-500 hover:border-blue-400 hover:shadow-md'
                  }`}
              >
                <input
                  type="radio"
                  name={name}
                  id={`radio-${name}-${option.value}`}
                  value={option.value}
                  onChange={onChange}
                  checked={value === option.value}
                  className="hidden"
                  disabled={disabled}
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        :
        <div className={`${style}`}>
          <div className="flex">
            {label !== "" &&
              <div className={`col-md-3`} >
                <label
                  className="form-label"
                  htmlFor={name}
                >
                  {required && <span className="text-danger"> * </span>}{label}
                </label>
              </div>
            }
            {options.map((option) => (
              <label
                key={option.value}
                htmlFor={`radio-${name}-${option.value}`}
                className={`cursor-pointer flex items-center px-4 py-2 rounded-full border-2 transition-all duration-300 
              ${value === option.value
                    ? 'font-semibold text-blue-500 border-blue-700 shadow-md'
                    : 'border-gray-300 bg-white text-gray-500 hover:border-blue-400 hover:shadow-md'
                  }`}
              >
                <input
                  type="radio"
                  name={name}
                  id={`radio-${name}-${option.value}`}
                  value={option.value}
                  onChange={onChange}
                  checked={value === option.value}
                  className="hidden"
                  disabled={disabled}
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
      }
    </>
  )
}

RadioButtonComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  field_name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
}

export default RadioButtonComponent
